import api from './Api';

const BASE_URL = 'auditLogs/';

export default {
    /**
     * Paginated audit trail. The server decides scope from the JWT — a
     * restricted admin silently gets only their own entries, so there is no
     * "show everything" flag to send.
     *
     * The response carries `canSeeAll` so the UI knows whether to render the
     * actor filter at all.
     */
    getAuditLogs: ({ page, limit, action, actorId, outcome, from, to, q, includeLogins } = {}) => {
        return api.get(BASE_URL, {
            params: { page, limit, action, actorId, outcome, from, to, q, includeLogins },
        });
    },
    getAuditActions: () => api.get(`${BASE_URL}actions`),
    getAuditActors: () => api.get(`${BASE_URL}actors`),
};
